// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";
import { SliderItemImg } from "./item_img/SliderItemImg";
import { SliderItemVideo } from "./item_video/SliderItemVideo";

Vue.component("TeaserModuleSliderItemImg", SliderItemImg);
Vue.component("TeaserModuleSliderItemVideo", SliderItemVideo);

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class TeaserModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public isVideo(column) {
    return (
      column["video"] &&
      column["video"] != "" &&
      (column["video"]["embedUrl"] || column["video"]["uploadUrl"])
    );
  }

  public isImage(imageObject) {
    return this.getTranslatedImage(imageObject, this.lang, "full");
  }
}
